// Roster health score card — extracted from RosterDetail.jsx iter34 for clarity.
// Pure presentational. Renders nothing if there is no score or no entries.

const HealthScoreCard = ({ healthScore, hasEntries }) => {
  if (!healthScore || !hasEntries) return null;

  const overall = healthScore.overall;
  const ringBg =
    overall >= 90 ? 'bg-emerald-50 dark:bg-emerald-900/30' :
    overall >= 70 ? 'bg-amber-50 dark:bg-amber-900/30' :
    'bg-red-50 dark:bg-red-900/30';
  const ringText =
    overall >= 90 ? 'text-emerald-700 dark:text-emerald-300' :
    overall >= 70 ? 'text-amber-700 dark:text-amber-300' :
    'text-red-700 dark:text-red-300';
  const label =
    overall >= 90 ? "Excellent" :
    overall >= 70 ? "Good" :
    overall >= 50 ? "Needs work" : "Critical";

  return (
    <div className="bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 p-4 sm:p-5" data-testid="health-score-card">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-center gap-4 flex-shrink-0">
          <div className={`relative w-20 h-20 rounded-full flex items-center justify-center ${ringBg}`}>
            <span className={`text-2xl font-bold tabular-nums ${ringText}`} data-testid="health-overall">{overall}</span>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400">Roster Health</p>
            <p className="text-base font-semibold text-zinc-900 dark:text-zinc-100 mt-0.5">{label}</p>
            <p className="text-xs text-zinc-500 dark:text-zinc-400">{healthScore.errors} errors, {healthScore.warnings} warnings</p>
          </div>
        </div>
        <div className="flex-1 grid grid-cols-2 sm:grid-cols-5 gap-3 w-full">
          {healthScore.categories.map((c, i) => (
            <div key={c.name || i} className="text-xs" data-testid={`health-cat-${i}`}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-zinc-500 dark:text-zinc-400 truncate">{c.name}</span>
                <span className="font-semibold tabular-nums text-zinc-900 dark:text-zinc-100">{c.score}</span>
              </div>
              <div className="h-1.5 bg-zinc-100 dark:bg-zinc-800 rounded overflow-hidden">
                <div className={`h-full rounded ${
                  c.score >= 90 ? 'bg-emerald-500' : c.score >= 70 ? 'bg-amber-500' : 'bg-red-500'
                }`} style={{ width: `${c.score}%` }} />
              </div>
              <p className="text-[10px] text-zinc-400 dark:text-zinc-500 mt-1 truncate" title={c.detail}>{c.detail}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HealthScoreCard;
